/* eslint-disable no-console */
/* eslint-disable import/no-mutable-exports */
/* eslint-disable no-unused-vars */
/* eslint-disable no-new */
import { initializeApp } from 'firebase/app';

import { getAuth } from 'firebase/auth';

import { getAnalytics } from 'firebase/analytics';
import { getDatabase } from 'firebase/database';
import { getStorage } from 'firebase/storage';

let auth;
let database;
let storage;
let firebaseApp = null; // Cache the Firebase app instance
let isInitialized = false; // Track initialization status

const firebaseInit = (firebaseConfig) =>
  new Promise((resolve, reject) => {
    // If already initialized, return success immediately
    if (isInitialized && firebaseApp) {
      resolve({ success: true, data: 'already initialized' });
      return;
    }

    try {
      // Initialize Firebase only once
      firebaseApp = initializeApp(firebaseConfig);

      auth = getAuth(firebaseApp);
      database = getDatabase(firebaseApp);
      storage = getStorage(firebaseApp);

      const analytics = getAnalytics(firebaseApp);

      if (database) {
        isInitialized = true;
        resolve({ success: true, data: 'success' });
      } else {
        resolve({ success: false, data: 'false' });
      }
    } catch (error) {
      // If error is "already initialized", that's okay
      if (error.code === 'app/duplicate-app') {
        isInitialized = true;
        resolve({ success: true, data: 'already initialized' });
      } else {
        console.error('Firebase initialization error:', error);
        resolve({ success: false, data: error.message });
      }
    }
  });

export { auth, database, storage, firebaseInit };
